import React, {useContext} from 'react';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../../@crema/utility/AppContext';
import {ThemeMode} from '../../constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import {useHistory} from 'react-router-dom';
const AppLogo = () => {
  const {themeMode} = useContext(AppContext);
  const useStyles = makeStyles((theme) => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
      padding:'0px 10px',     
      justifyContent:'center',
      [theme.breakpoints.down('md')]: {
        width:'15%',
        maxWidth:'15%',
      },
      [theme.breakpoints.up('md')]: {
  width:'7%',
  maxWidth:'7%',
      },
    },
    logo: {
      //height: 36,
      height: '37px',
      // marginRight: 10,
    },
  }));
  const classes = useStyles();
  const history = useHistory();
  //Go to dahboard
  const goToDashboard = async () => {
    history.push('/');
  };
  return (
    <Box className={classes.logoRoot} onClick={() => goToDashboard()}>
      <Hidden smUp>
        <img
          className={classes.logo}
          src={
            // themeMode === ThemeMode.DARK
            //   ? '/assets/images/logo-white.png'
            //   : '/assets/images/logo.png'
            themeMode === ThemeMode.DARK
              ? '/assets/images/gudmed-top-logo.png'
              : '/assets/images/gudmed-top-logo.png'
          }
          alt='gudmed-logo'
        />
      </Hidden>
      <Hidden xsDown>
        <img
          className={classes.logo}
          src={
            // themeMode === ThemeMode.DARK
            //   ? '/assets/images/logo-white-with-name.png'
            //   : '/assets/images/logo-with-name.png'
            themeMode === ThemeMode.DARK
              ? '/assets/images/gudmed-top-logo.png'
              : '/assets/images/gudmed-top-logo.png'
          }
          alt='gudmed-logo'
        />
      </Hidden>
    </Box>
  );
};

export default AppLogo;
